import { closeModal } from 'store/modules/ModalActions';
import { GenericModal } from 'components/GenericModal';
import { CustomButton } from 'components/CustomButton';
import { Row } from 'components/Row';
import './index.scss';
import { Grid } from '@material-ui/core';
import { clearUploadedFile } from 'store/modules/AllContratos/AllContratosActions';
import { useDispatch, useSelector } from 'react-redux';

interface ModalConfirmProps {
    title: string;
    content: string | React.ReactNode;
    confirmCallback: () => void;
    cancelCallback?: () => void;
    confirmLabel?: string;
    cancelLabel?: string;
    modalKey: string;
    maxWidth: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    showCancelButton?: boolean;
    closeCallbackIcon?: () => void;
}

const ModalConfirm = ({
    title,
    content,
    confirmCallback,
    cancelCallback,
    confirmLabel,
    cancelLabel,
    modalKey,
    maxWidth,
    showCancelButton = true,
    closeCallbackIcon
}: ModalConfirmProps) => {
    const dispatch = useDispatch();
    const languageValues = useSelector((states: any) => states.languages.languageValues);

    const handleClose = (callback: any) => {
        if (callback) {
            callback();
        }
        dispatch(closeModal(modalKey));
    };

    const toCancel = () => {
        dispatch(clearUploadedFile());
        handleClose(cancelCallback);
    };

    const toConfirm = () => {
        handleClose(confirmCallback);
    };

    const handleModalClose = () => {
        if (closeCallbackIcon) {
            closeCallbackIcon();
        }
        handleClose(null);
    };

    return (
        <GenericModal
            id={'contratos-modal-confirm__id'}
            className='contratos-modal-confirm'
            onClose={handleModalClose}
            DialogProps={{
                disableBackdropClick: false,
                disableEscapeKeyDown: false,
                maxWidth: maxWidth,
                fullWidth: true,
            }}
            title={title}
            footerContent={
                <Grid container spacing={1} className='contratos-modal-confirm__gridContainer-buttons'>
                    {showCancelButton && (
                        <Grid item>
                            <CustomButton
                                id={'contratos-modal-confirm__cancel'}
                                theme='pufvYellow'
                                className='contratos-modal-confirm__cancel-button'
                                label={cancelLabel || languageValues.cancelButton}
                                onClick={toCancel}
                            />
                        </Grid>
                    )}
                    <Grid item>
                        <CustomButton
                            id={'contratos-modal-confirm__confirm'}
                            theme='pufvYellow'
                            className='contratos-modal-confirm__confirm-button'
                            label={confirmLabel || languageValues.salvar}
                            onClick={toConfirm}
                        />
                    </Grid>
                </Grid>
            }
        >
            <Row>
                {content}
            </Row>
        </GenericModal>
    );
};

export default ModalConfirm;
